import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { productImage } from "@/lib/images";

export default function ProductCard({ product, index = 0 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.5, delay: index * 0.05, ease: [0.2, 0.7, 0.2, 1] }}
      data-testid={`product-card-${product.id}`}
    >
      <Link
        to={`/product/${product.id}`}
        className="group block card-soft p-4 transition-all hover:-translate-y-1 hover:shadow-[0_18px_36px_rgba(217,119,87,0.10)]"
      >
        <div className="overflow-hidden rounded-2xl bg-[#F4EFE6] aspect-[4/5]">
          <img
            src={productImage(product.image_url)}
            alt={product.name}
            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
          />
        </div>
        <div className="px-1 pt-5 pb-2 flex items-start justify-between gap-4">
          <div>
            <div className="text-[11px] uppercase tracking-[0.18em] text-[#5C4D43]">
              {product.category}{product.size ? ` · ${product.size}` : ""}
            </div>
            <div className="font-serif text-xl mt-1 leading-tight">{product.name}</div>
          </div>
          <div className="font-serif text-xl text-[#D97757] whitespace-nowrap">
            £{product.price?.toFixed(0)}
          </div>
        </div>
      </Link>
    </motion.div>
  );
}
